import { createContext, FC, useContext, useState } from "react"
import { SearchReportsSales, WithChildren } from "../../../../_metronic/helpers"

interface IFilterContext {
    filterExport: SearchReportsSales
    setFilterExport: React.Dispatch<React.SetStateAction<SearchReportsSales>>
}

const FilterContext = createContext<IFilterContext>({} as IFilterContext)

const FilterProvider: FC<WithChildren> = ({ children }) => {

    const [filterExport, setFilterExport] = useState<SearchReportsSales>({})

    return (
        <FilterContext.Provider
            value={{
                filterExport,
                setFilterExport,
            }}
        >
            {children}
        </FilterContext.Provider>
    )
}

const useFilterExport = () => useContext(FilterContext)
export { FilterProvider, useFilterExport }
